import { useEffect, useState } from 'react';
import { Avatar, Box, Card, CardContent, Grid, Typography } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import PeopleIcon from '@mui/icons-material/PeopleOutlined';
import Conexion from '../../../Conexion/Conexion';

const { apiUrl } = Conexion();

async function obtenerDato() {
  return fetch(`${apiUrl}/api/dashboard/usuarios-activos`, {
      method: 'GET',
      headers: {
          'Content-Type': 'application/json',
          'Authorization': sessionStorage.getItem('token')
      }
  })
      .then(result => result.json())
}

const UsuariosActivos = (props) => {
  const [state, setState] = useState([{monto:0}]);

  const cargarDatos = async () => {
    const usuarios = await obtenerDato();
    if (usuarios.ok) {
      setState(usuarios.data);
    }
  }

  useEffect(() => {
    cargarDatos();
  }, []);

  return(
    <Card {...props}>
      <CardContent>
        <Grid
          container
          spacing={3}
          sx={{ justifyContent: 'space-between' }}
        >
          <Grid item>
            <Typography
              color="textSecondary"
              gutterBottom
              variant="overline"
              className='semiBold'
            >
              USUARIOS ACTIVOS
            </Typography>
            <Typography
              color="textPrimary"
              variant="h4"
            >
              {state[0].count || 0}
            </Typography>
          </Grid>
          <Grid item>
            <Avatar
              sx={{
                backgroundColor: 'error.main',
                height: 56,
                width: 56
              }}
            >
              <PeopleIcon />
            </Avatar>
          </Grid>
        </Grid>
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            pt: 2
          }}
        >
          {/* <ArrowUpwardIcon color="success" />
          <Typography
            variant="body2"
            sx={{
              mr: 1
            }}
          >
            16%
          </Typography> */}
          <Typography
            color="textSecondary"
            variant="caption"
          >
            Usuarios con eventos activos
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
}

export default UsuariosActivos;